/** Shared deadline for API calls. Wake recovery aborts these immediately. */

export const API_DEADLINE_MS = 20_000;

const controllers = new Set<AbortController>();

export function inFlightRequestCount(): number {
  return controllers.size;
}

export function abortInFlightGets(): void {
  for (const controller of [...controllers]) {
    controller.abort(new Error("Request timed out while the page was asleep"));
  }
  controllers.clear();
}

export async function fetchWithDeadline(url: string, init: RequestInit): Promise<Response> {
  const controller = new AbortController();
  controllers.add(controller);
  const timeout = globalThis.setTimeout(() => {
    controller.abort(new Error(`Request timed out while loading ${url}`));
  }, API_DEADLINE_MS);
  try {
    return await fetch(url, { ...init, signal: controller.signal });
  } finally {
    globalThis.clearTimeout(timeout);
    controllers.delete(controller);
  }
}
